export { default as basicInsightActions } from './basic'
export { default as shareInsightActions } from './share'
export { default as templatesInsightActions } from './templates'
export * from './custom'